module.exports = __webpack_public_path__ + "static/media/ic_lactancia_seleccionado.1ef07631.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/services/ic_lactancia_seleccionado.webp
// module id = 180
// module chunks = 1